import React from 'react'

function Footer() {
    return (
        <footer id="footer" className="bg-dark">
            {/* <div className="container">
                <div className="row">
                    <div className="col-sm-4">
                        <h4>Quick Links</h4>
                        <hr />
                        <ul className="nav flex-column ">
                            <li className="nav-item">
                                <a href="" className="nav-link">Home </a>
                            </li>
                            <li className="nav-item">
                                <a href="" className="nav-link">About </a>
                            </li>
                            <li className="nav-item">
                                <a href="" className="nav-link">Contact </a>
                            </li>
                            <li className="nav-item">
                                <a href="" className="nav-link">Help</a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-sm-4">
                        <h4>Quick Links</h4>
                        <hr />
                        <ul className="nav flex-column ">
                            <li className="nav-item">
                                <a href="" className="nav-link">Home </a>
                            </li>
                            <li className="nav-item">
                                <a href="" className="nav-link">About </a>
                            </li>
                            <li className="nav-item">
                                <a href="" className="nav-link">Contact </a>
                            </li>
                            <li className="nav-item">
                                <a href="" className="nav-link">Help</a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-sm-4">
                        <h4>Contact us</h4>
                        <hr />
                        <div> address line 1<br /> address line 2<br /> address line 3 </div>
                    </div>
                </div>
            </div> */}
            <article className="footerLine mt-4 bg-black bg-opacity-50 text-center py-1">
                <small>Copyright &copy; {new Date().getFullYear()}</small>
            </article>
        </footer>
    )
}

export default Footer